import { type FC } from 'react';
import { Badge, Blockquote, Card, Stack, Text } from '@mantine/core';
import { IconMessage } from '@tabler/icons-react';
import { formatTicket, payinTicketPriorityColors, payinTicketStatusColors, type PayinTicket } from '~/entities/payin';
import { KeyValuePair } from '~/shared/ui/KeyValuePair';
import s from './style.module.css';

interface TicketDetailsProps {
    ticket: PayinTicket;
}

export const TicketDetails: FC<TicketDetailsProps> = ({ ticket }) => {
    return (
        <Card p={10}>
            <Card.Section
                withBorder
                inheritPadding
                py={10}
            >
                <KeyValuePair
                    label='ID'
                    value={<Text>{ticket.id?.value || '-'}</Text>}
                    direction='row'
                />
            </Card.Section>

            <Stack>
                <Blockquote
                    radius={0}
                    my='xl'
                    color='blue'
                    px='xs'
                    icon={<IconMessage />}
                    className={s.message}
                >
                    {ticket.message}
                </Blockquote>

                {ticket.status && (
                    <KeyValuePair
                        label='Статус'
                        direction='row'
                        value={
                            <Badge
                                color={payinTicketStatusColors[ticket.status]}
                                fz='xs'
                            >
                                {formatTicket.status(ticket.status)}
                            </Badge>
                        }
                    />
                )}

                {ticket.priority && (
                    <KeyValuePair
                        label='Приоритет'
                        direction='row'
                        value={
                            <Badge
                                color={payinTicketPriorityColors[ticket.priority]}
                                fz='xs'
                            >
                                {formatTicket.priority(ticket.priority)}
                            </Badge>
                        }
                    />
                )}

                {ticket.createdAt && (
                    <KeyValuePair
                        label='Дата создания'
                        direction='row'
                        value={formatTicket.date(ticket.createdAt)}
                    />
                )}
            </Stack>
        </Card>
    );
};
